__turbopack_context__.v({
  "active": "ContentHeader-module__26zvCq__active",
  "chevron-icon": "ContentHeader-module__26zvCq__chevron-icon",
  "child-item": "ContentHeader-module__26zvCq__child-item",
  "childrenSubmenu": "ContentHeader-module__26zvCq__childrenSubmenu",
  "clickLinks": "ContentHeader-module__26zvCq__clickLinks",
  "dactive": "ContentHeader-module__26zvCq__dactive",
  "dpactive": "ContentHeader-module__26zvCq__dpactive",
  "dropdown-submenu": "ContentHeader-module__26zvCq__dropdown-submenu",
  "dropdown-toggle": "ContentHeader-module__26zvCq__dropdown-toggle",
  "dropdownLinkContainer": "ContentHeader-module__26zvCq__dropdownLinkContainer",
  "dropdownToggle": "ContentHeader-module__26zvCq__dropdownToggle",
  "has-children": "ContentHeader-module__26zvCq__has-children",
  "hideSubMenu": "ContentHeader-module__26zvCq__hideSubMenu",
  "menuIcon": "ContentHeader-module__26zvCq__menuIcon",
  "menuList": "ContentHeader-module__26zvCq__menuList",
  "parentLink": "ContentHeader-module__26zvCq__parentLink",
  "sectionHeader": "ContentHeader-module__26zvCq__sectionHeader",
  "subMenu": "ContentHeader-module__26zvCq__subMenu",
});
